interface KeywordMatchCountProps {
  count: number
}

const KeywordMatchCount = ({ count }: KeywordMatchCountProps): JSX.Element | null => {
  if (count < 1) return null
  return (
    <div className='flex justify-end mt2 f7 grey'>
      + {count} more matches
    </div>
  )
}

export default KeywordMatchCount
